import React from 'react';
import {
  Routes,
  Route
} from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange';
import WhatsAppFloatingButton from './components/WhatsAppFloatingButton';
import FloatingCartButton from './components/FloatingCartButton';
import TopBarContact from './components/layout/TopBarContact';
import Layout from './components/layout/Layout';

import IndexPage from './pages/Index.js';
import AboutUsPage from './pages/About_us.js';
import ContactPage from './pages/Contact.js';
import BlogsPage from './pages/Blogs.js';
import ProductPage from './pages/Product.js';
import BlogPage from './pages/Blog.js';
import CategoryProductsPage from './components/custom-components/CategoryProductsPage.js';
import Categories from './pages/Categories.js';
import NotFound from './pages/NotFound.js';
import ThankYou from './pages/ThankYou.js';
import ProductCatalog from './components/ProductCatalog';

import { CartProvider } from "./context/CartContext";
import CartPage from "./components/cart/CartPage";

import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function App() {
  const location = useLocation();
  const isCatalogPage = location.pathname === '/catalog';
  return (
    <HelmetProvider>
      <Helmet>
        <title>Bagga International | Tool Bags, Pouches & Belts</title>
        <meta name="description" content="Bagga International offers high-quality tool bags, pouches, belts, and more for professionals and enthusiasts. Browse our categories and products." />
        <meta property="og:title" content="Bagga International | Tool Bags, Pouches & Belts" />
        <meta property="og:description" content="Bagga International offers high-quality tool bags, pouches, belts, and more for professionals and enthusiasts." />
        <meta property="og:image" content="/images/site-default-og.jpg" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Bagga International | Tool Bags, Pouches & Belts" />
        <meta name="twitter:description" content="Bagga International offers high-quality tool bags, pouches, belts, and more for professionals and enthusiasts." />
        <meta name="twitter:image" content="/images/site-default-og.jpg" />
        <link rel="canonical" href="https://baggainternational.com/" />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <CartProvider>
        <ScrollToTop />
        {!isCatalogPage && <TopBarContact />}
        <ScrollToTopOnRouteChange />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<IndexPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogsPage />} />
            <Route path="/categories/:categoryId/:productId" element={<ProductPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/blog/:blogId" element={<BlogPage />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/categories/:categoryId" element={<CategoryProductsPage />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/catalog" element={<ProductCatalog />} />
        </Routes>
        <FloatingCartButton />
        {!isCatalogPage && <WhatsAppFloatingButton />}
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
